import React from "react";
import { useNavigate } from "react-router";

function TaxonomyIndex() {
  const navigate = useNavigate();
  return (
    <div className="container-fluid" data-testid="taxonomy-page">
      <h2>Dashboard</h2>
      <hr />
      <div className="row">
        <div className="col-sm-4">
          <div className="mb-3 card border-dark">
            <div className="card-body text-dark">
              <h5 className="card-title">Categories</h5>
              <p className="card-text">
                Categories
              </p>
              <button
                className="btn btn-primary btn-sm"
                data-testid="taxonomy-categories-explore-btn"
                onClick={() => navigate("/gms/categories", { replace: true })}
              >
                Explore
              </button>
            </div>
          </div>
        </div>
        <div className="col-sm-4">
          <div className="mb-3 card border-dark">
            <div className="card-body text-dark">
              <h5 className="card-title">Attributes</h5>
              <p className="card-text">Attributes</p>
              <button
                className="btn btn-primary btn-sm"
                data-testid="taxonomy-attributes-explore-btn"
                onClick={() => navigate("/gms/attributes", { replace: true })}
              >
                Explore
              </button>
            </div>
          </div>
        </div>
    </div>
    </div>
  );
}

export default TaxonomyIndex;
